export default "__VITE_ASSET__2d8633c5__"